import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import {
  aggregationOptions,
  groupedByOptions,
} from 'modules/reviews/components/Analytics/utilities'
import { useAnalytics } from 'modules/reviews/pages/performance/Show/Analytics/analyticsContext'
import { GroupedBy } from 'modules/surveys/store/models/AnalyticResult'

import type ScoreForm from '../ScoreForm'

interface Props {
  scoreForm: ScoreForm
}

const Filters = ({ scoreForm }: Props) => {
  const { questionCategories } = useAnalytics()

  if (!questionCategories.length) return null

  const groupedBy = scoreForm.get('grouped_by').value
  const isSectionsSelected = groupedBy === GroupedBy.Sections

  return (
    <Box flexDirection="row" gap="s16">
      <Box width="s240">
        <Select
          label={i18n.t('surveys.review.analytics.score.group_by.label')}
          options={groupedByOptions()}
          field={scoreForm.get('grouped_by')}
        />
      </Box>
      {isSectionsSelected && (
        <Box width="s240">
          <Select
            label={i18n.t('surveys.review.analytics.score.aggregate.label')}
            options={aggregationOptions()}
            field={scoreForm.get('aggregate_operation')}
          />
        </Box>
      )}
    </Box>
  )
}

export default observer(Filters)
